export default function Review() {
    const play = document.querySelectorAll('.reviews__play');

    play && play.forEach((item) => {
        const cover = item.previousElementSibling.previousElementSibling;

        item && item.addEventListener('click', (e) => {
            item.classList.add('hidden');
            cover.classList.add('hidden');

            const videoSrc = item.dataset.video;
            const url = new URL(videoSrc);
            const iframeId = new URLSearchParams(url.search).get('p');
            const iframe = document.createElement('iframe');

            iframe.setAttribute('src', `${videoSrc}&mute=1`);
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%;');
            iframe.setAttribute('allow', 'autoplay');
            iframe.setAttribute('id', iframeId);
            item.insertAdjacentElement('afterend', iframe);

            iframe.onload = () => {
                iframe.contentWindow.postMessage(JSON.stringify({
                    type: 'player:play',
                    data: {}
                }), '*');
            };
        });
    });
}
